export default __webpack_public_path__ + "assets/a2ca34c391de073172d480fe7977954a.jpg";